import React from 'react'
import { FaCoins, FaExclamationTriangle, FaFileSignature, FaUsers } from 'react-icons/fa';
import { useDMSContext } from '../../context/DMSContext'
import { useScreenWidth } from '../../hooks/useScreenWidth';
import Card from '../../UI/Card/Card'

export default function DashboardSection() {
  const { statistics } = useDMSContext();

  
  const statsConfig = [
    {
      icon: <FaUsers size={28} color="var(--prolex-blue)" />,
      label: "Total Debitori",
      value: (statistics?.totalDebtors ?? 0),
      valueStyle: { fontSize: "32px", fontWeight: "600" }
    },
    {
      icon: <FaCoins size={28} color="var(--prolex-green)" />,
      label: "Valoare Totală Datorată",
      value: `${statistics?.totalDebtValue ?? 0} MDL`,
      valueStyle: { fontSize: "32px", fontWeight: "600", color: "var(--prolex-red)" }
    },
    {
      icon: <FaFileSignature size={28} color="var(--prolex-blue)" />,
      label: "Contracte Active",
      value: (statistics?.activeContracts ?? 0),
      valueStyle: { fontSize: "32px", fontWeight: "600" }
    },
    {
      icon: <FaExclamationTriangle size={28} color="var(--prolex-orange)" />,
      label: "Debitori cu Restanțe Critice",
      value: (statistics?.criticalDebtors ?? 0),
      valueStyle: { fontSize: "32px", fontWeight: "600", color: "var(--prolex-orange)" }
    }
  ];
  return (
    <div className='dms-content'>
     <div className="stats-grid">
        {statsConfig.map((stat, i) => (
          <Card key={i} style={{padding:"1.5rem"}}>
            <div className="stat-widget">
              <span>{stat.icon}</span>
              <span style={{ fontSize: "18px", fontWeight: "500", color: "gray" }}>
                {stat.label}
              </span>
              <span style={stat.valueStyle}>{stat.value}</span>
            </div>
          </Card>
        ))}
      </div>
      <div className="analysis-grid">
        <Card>
          <h3>Distribuția Datoriilor pe Vechime</h3>
          <ul className="debt-distribution">
            {Object.entries(statistics?.debtDistribution ?? {}).map(([range, value]) => (
              <li key={range}>
                <span>{range} zile:</span>
                <span>{value.toFixed(2)} MDL</span>
              </li>
            ))}
          </ul>
        </Card>

        <Card>
          <h3>Top 5 Debitori cu Cele Mai Mari Restanțe</h3>
          <ul className="top-debtors">
            {(statistics?.topDebtors ?? []).map((debtor, i) => (
              <li key={i}>
                <span>{debtor.name}</span>
                <span className="debt-value">{debtor.debt.toFixed(2)} MDL</span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  )
}
